<button class="exit-button" (click)="onCancelScan()">
  <i nz-icon [nzType]="'icons:exit'" class="svg-icon"></i>
</button>

<div class="header body-bold">
  @if (matrixCode()) {
    {{ i18n.langString("scanning_matrix_code") }}
  } @else {
    {{ i18n.langString("scanning_qr_code") }}
  }
</div>

<div class="container">
  <div
    class="upper-left"
    [class.border-red]="error()"
    [class.border-green]="success()"
    [class.border-white]="!error() && !success()"
  ></div>
  <div
    class="upper-right"
    [class.border-red]="error()"
    [class.border-green]="success()"
    [class.border-white]="!error() && !success()"
  ></div>
  <div
    class="lower-left"
    [class.border-red]="error()"
    [class.border-green]="success()"
    [class.border-white]="!error() && !success()"
  ></div>
  <div
    class="lower-right"
    [class.border-red]="error()"
    [class.border-green]="success()"
    [class.border-white]="!error() && !success()"
  ></div>
</div>

<div class="wrapper">
  <img #img [src]="image()" />
</div>

<div class="footer-inner-wrapper">
  @if (!isMobile) {
    <app-nav-button [svgIcon]="'icons:fixed'" [primary]="true" class="hidden">{{
      i18n.langString("wait_for_qr_code")
    }}</app-nav-button>
  }

  <span class="black-text centered-text">
    @if (matrixCode()) {
      {{ i18n.langString("wait_for_matrix_code") }}
    } @else {
      {{ i18n.langString("wait_for_qr_code") }}
    }
  </span>

  @if (!isMobile) {
    <app-nav-button [svgIcon]="'icons:fixed'" [primary]="true" class="hidden">{{
      i18n.langString("wait_for_qr_code")
    }}</app-nav-button>
  }
</div>
